module.exports = __webpack_public_path__ + "static/assets/4555e8b691e842b0d459d451bb259f4d.gif";